import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormTextInput } from 'components/form-fields';
import { Button } from 'components/buttons';
import { ShowHide } from 'components/layout';
import './Comment.css';

export function Comment(
    {
        id = null,
        color = "",
        selected = false,
        disabled = false,
        onClick = () => { },
        onDelete = () => { },
        value = "",
        isEditibleInitially = false,
        headerText = null,
        headingText = null,
        showActions = true,
        className,
        onSave
    }
) {

    const maxCommentSize = 256;

    const [isEditing, setisEditing] = useState(isEditibleInitially);
    const [comment, setComment] = useState(value ?? "");

    useEffect(() => {
        setComment(value);
    }, [value]);

    function handleIsEditingChange(editible){
        setisEditing(editible);
    }

    function onCommentChange(event){
        if (event.target.value === undefined) { return; }

        setComment(event.target.value);
    }

    function onSaveComment(){
        onSave(comment);
        handleIsEditingChange(false);
    }

    function onDeleteComment(){
        onDelete();
        setComment("");
        handleIsEditingChange(false);
    }

    function hasComment(){
        if (!comment){
            return false;
        }
        return comment.length > 0;
    }

    return (
        <div className={classNames('comment-component', className)}
            id={id}
        >
            <ShowHide
                evaluator={headerText != null}
                show={<h3 className="comment-header">{headerText}</h3>}
            />
            <div className="inline-items">
                <FormTextInput 
                    disabled={!isEditing} 
                    onChange={onCommentChange} 
                    value={comment ?? ""} 
                    id={`${id}-comment`}
                    maxLength={maxCommentSize}
                    headingText={headingText}
                />
                    
                <ShowHide evaluator={showActions} show={<ShowHide evaluator={!isEditing} show={(
                    <>
                        <Button
                            iconOnly={true}
                            icon={"edit"}
                            minimal={true}
                            large={false}
                            onClick={() => handleIsEditingChange(true)}
                        />
                        <Button
                            iconOnly={true}
                            icon={"trash"}
                            minimal={true}
                            intent="danger"
                            large={false}
                            onClick={onDeleteComment}
                        />
                    </>
                )}
                hide={(
                    <>
                        <Button
                            iconOnly={true}
                            icon={"cross"}
                            minimal={true}
                            large={false}
                            onClick={() => handleIsEditingChange(false)}
                        />          
                        <Button
                            iconOnly={true}
                            icon={"floppy-disk"}
                            minimal={false}
                            intent='primary'
                            large={false}
                            onClick={onSaveComment}
                            disabled={!hasComment()}
                        />
                    </>
                )} />
                } />
            </div>
        </div>
    );
}

Comment.propTypes = {
    id: PropTypes.string,
    onClick: PropTypes.func,
    onSave: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    className: PropTypes.string,
    value: PropTypes.string,
    isEditibleInitially: PropTypes.bool,
    headerText: PropTypes.string,
    headingText: PropTypes.string,
    showActions: PropTypes.bool,
};